import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { FullPageSkeleton } from "./ui/Skeleton";

const PrivateRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [user, setUser] = useState(null);
  const [authError, setAuthError] = useState("");
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      const fetchUserData = async () => {
        try {
          const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/user`, {
            headers: { Authorization: `Bearer ${token}` },
          });

          if (!response.ok) {
            let errMsg = "Session expired or access denied.";
            try {
              const errData = await response.json();
              if (errData.message) errMsg = errData.message;
            } catch (e) {}
            localStorage.removeItem("token");
            localStorage.removeItem("userId");
            sessionStorage.setItem("loginErrorMessage", errMsg);
            setAuthError(errMsg);
            throw new Error(errMsg);
          }

          const data = await response.json();
          setUser(data.user);
          setIsAuthenticated(true);
        } catch (error) {
          console.error(error);
          setIsAuthenticated(false);
        }
      };

      fetchUserData();
    } else {
      setIsAuthenticated(false);
    }
  }, []);

  if (isAuthenticated === null) {
    return (
      <div className="flex items-center justify-center min-h-[60vh] p-4">
        <div className="w-full max-w-5xl">
          <FullPageSkeleton message="Loading..." />
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location, blockedMessage: authError }} />;
  }

  // Special check for service routes
  const serviceRoutes = {
    '/service1': 'isUSAEnabled',
    '/tax-filing': 'isTaxFilingEnabled',
    '/bookkeeping': 'isBookkeepingEnabled',
    '/cfo': 'isCFOEnabled',
    '/registered-agent': 'isRegisteredAgentEnabled',
    '/annual-report': 'isAnnualReportServiceEnabled',
    '/sales-tax': 'isSalesTaxEnabled',
    '/sales-tax-module': 'isSalesTaxEnabled',
  };

  const currentPath = location.pathname;

  if (user && (user.isAssignee || user.isBookkeepingCollaborator)) {
    if (currentPath !== '/bookkeeping') {
      return <Navigate to="/bookkeeping" />;
    }
  }

  if (serviceRoutes[currentPath] && !user[serviceRoutes[currentPath]]) {
    return <Navigate to="/pricing" state={{ from: location }} />;
  }

  return children;
}


export default PrivateRoute;
